import { StatelessComponent, MouseEvent } from 'react'
import * as cn from 'classnames'
import * as styles from 'styles/atoms/balloons/Balloon.css'

export type BalloonArrowDirection = 'left' | 'right' | 'up' | 'down'

type BalloonProps = {
  centered?: boolean
  arrowDirection?: BalloonArrowDirection
}

const handleBalloonClick = (event: MouseEvent<HTMLDivElement>) => {
  event.preventDefault() // mousedown causes blur that prevents click event
}

const Balloon: StatelessComponent<BalloonProps> = ({ children, centered, arrowDirection }) => {
  const rootClass = cn(styles.balloon, {
    [styles.leftArrow]: arrowDirection === 'left',
    [styles.rightArrow]: arrowDirection === 'right',
    [styles.upArrow]: arrowDirection === 'up',
    [styles.downArrow]: arrowDirection === 'down',
  })

  return (
    <div className={ rootClass } onMouseDown={ handleBalloonClick }>
      <div
        className={ cn(styles.balloonInner, {
          [styles.centered]: centered,
        }) }
      >
        { children }
      </div>
    </div>
  )
}

Balloon.defaultProps = {
  arrowDirection: 'left',
}

export default Balloon
